import { create } from "zustand";
import { Aircraft } from "../../../../../types";

interface ReferenceAircraftPosition {
  x: number; // in feet
  y: number; // in feet
  angle: number; // in radians
}

interface ReferenceAircraftState {
  // Data
  aircraft: Aircraft | null;
  position: ReferenceAircraftPosition;
  loadedImage: HTMLImageElement | null;

  // UI State
  isSelected: boolean;
  isDialogOpen: boolean;
  isDragging: boolean;

  // Actions
  setAircraft: (aircraft: Aircraft | null) => void;
  setPosition: (position: ReferenceAircraftPosition) => void;
  setLoadedImage: (image: HTMLImageElement | null) => void;
  setIsSelected: (selected: boolean) => void;
  setIsDialogOpen: (open: boolean) => void;
  setIsDragging: (dragging: boolean) => void;
  rotate: (deltaRadians: number) => void;
  clear: () => void;
}

const DEFAULT_POSITION: ReferenceAircraftPosition = {
  x: 0,
  y: 0,
  angle: 0,
};

export const useReferenceAircraftState = create<ReferenceAircraftState>(
  (set, get) => ({
    // Initial state
    aircraft: null,
    position: DEFAULT_POSITION,
    loadedImage: null,
    isSelected: false,
    isDialogOpen: false,
    isDragging: false,

    // Actions
    setAircraft: (aircraft) => {
      set({ aircraft, loadedImage: null });
    },

    setPosition: (position) => {
      set({ position });
    },

    setLoadedImage: (loadedImage) => {
      set({ loadedImage });
    },

    setIsSelected: (isSelected) => {
      set({ isSelected });
    },

    setIsDialogOpen: (isDialogOpen) => {
      set({ isDialogOpen });
    },

    setIsDragging: (isDragging) => {
      set({ isDragging });
    },

    rotate: (deltaRadians) => {
      const { position } = get();
      set({
        position: {
          ...position,
          angle: position.angle + deltaRadians,
        },
      });
    },

    clear: () => {
      set({
        aircraft: null,
        position: DEFAULT_POSITION,
        loadedImage: null,
        isSelected: false,
        isDialogOpen: false,
        isDragging: false,
      });
    },
  })
);
